
function randomSelector(lenght: number): string{
  return `s${Math.random().toString(36).substr(2, lenght)}`;
}

export const randomUtils = {
  randomSelector
}
